// ============================================================================
// BOQ — measurement row clipboard (module-level, survives tab switches)
// ============================================================================
// Holds copied/cut measurement rows so a copy in a line's take-off sheet can
// be pasted in another line's sheet or in the Measurements tab. Each entry
// keeps the geometry + location + the source row's line links (itemIds).
// ============================================================================

let rows = [];
const listeners = new Set();

function emit() { listeners.forEach((l) => l()); }

export function setClipboardRows(next) {
  rows = next || [];
  emit();
}

export function getClipboardRows() {
  return rows;
}

export function subscribeClipboard(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
